import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-cyan-300 text-black text-center p-7">
      <p>&copy; 2024 Tamiyah Qazi. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
